import { Show } from 'framework/show';
import { useProjectId } from 'domain/shared/project';
import useProjectReviewService from './useProjectReviewService';
import ProjectReviewContent from './ProjectReviewContent';

const ProjectReviewLayout = () => {
  const projectId = useProjectId();
  const { getLatestProjectReview } = useProjectReviewService();

  const getDataMethod = async () => ({
    currentProjectReview: null,
    latestProjectReview: await getLatestProjectReview(projectId),
  });

  return (
    <Show getDataMethod={getDataMethod}>
      <ProjectReviewContent />
    </Show>
  );
};

export default ProjectReviewLayout;
